import { EditorState, RichUtils } from 'draft-js'
import { createPlugin } from 'draft-extend'
import IconSVG from 'svg-inline-react'
import cx from 'classnames'

import boldIconSrc from '!svg-inline?removeTags=true!./bold.svg'
import italicIconSrc from '!svg-inline?removeTags=true!./italic.svg'
import underlineIconSrc from '!svg-inline?removeTags=true!./underline.svg'
import listBulletsIconSrc from '!svg-inline?removeTags=true!./list-bullets.svg'
import listNumbersIconSrc from '!svg-inline?removeTags=true!./list-numbers.svg'

const ToolbarButton = ({ iconSrc, onClick, active }) => {
  return (
    <div className={cx('rich-editor-toolbar-button', { active })} onClick={onClick}>
      <IconSVG src={iconSrc}/>
    </div>
  )
}

const BLOCK_TYPES = [
  { iconSrc: listBulletsIconSrc, style: 'unordered-list-item' },
  { iconSrc: listNumbersIconSrc, style: 'ordered-list-item' },
]

const INLINE_STYLES = [
  { iconSrc: boldIconSrc, style: 'BOLD' },
  { iconSrc: italicIconSrc, style: 'ITALIC' },
  { iconSrc: underlineIconSrc, style: 'UNDERLINE' },
]

const createBlockStyleButton = ({ iconSrc, style }) => {
  return ({ editorState, onChange }) => {
    const toggleStyle = () => {
      onChange(
        RichUtils.toggleBlockType(
          editorState,
          style
        )
      )
    }
    const currentBlockStyle = editorState
      .getCurrentContent()
      .getBlockForKey(editorState.getSelection().getStartKey())
      .getType()
    const isActive = currentBlockStyle === style
    return (
      <ToolbarButton
        active={isActive}
        iconSrc={iconSrc}
        onClick={toggleStyle}
      />
    )
  }
}

const createInlineStyleButton = ({ iconSrc, style }) => {
  return ({ editorState, onChange }) => {
    const toggleStyle = () => {
      onChange(
        RichUtils.toggleInlineStyle(
          editorState,
          style
        )
      )
    }
    const currentInlineStyle = editorState.getCurrentInlineStyle()
    const isActive = currentInlineStyle.has(style)
    return (
      <ToolbarButton
        active={isActive}
        iconSrc={iconSrc}
        onClick={toggleStyle}
      />
    )
  }
}

export default createPlugin({
  buttons: [
    ...INLINE_STYLES.map(createInlineStyleButton),
    ...BLOCK_TYPES.map(createBlockStyleButton),
  ]
})



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Editor/plugins/blockStyles/index.js